import axios from 'axios'

const deploymentapi = axios.create({
  // @ts-ignore
  baseURL: window.configuration.DEPLOYMENT_API_URL,
})

axios.interceptors.response.use(function (response) {
  return response
}, function(error) {
  // remove the token and the expiration from the session storage
  window.sessionStorage.removeItem('deployment_auth')
  window.sessionStorage.removeItem('deployment_expiration')
  return error
})

export default deploymentapi